import { makeShouldUseNewWizardExp } from "areas/product/jewlr"
import Shimmer from "components/ui/shimmer"

const WizardLoading = () => {
  const shouldUseNewWizardExp = makeShouldUseNewWizardExp()

  if (shouldUseNewWizardExp) {
    return [...Array(3)].map((_, i) => (
      <div className="border-b-grey-10 border-b" key={`load${i}`}>
        <div className="flex items-center justify-between py-16">
          <Shimmer className="h-18 w-160" />
          <Shimmer className="h-18 w-60" />
        </div>
      </div>
    ))
  }

  return [...Array(3)].map((_, i) => (
    <div className="border-b-grey-10 border-b bg-white p-10" key={`load${i}`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <Shimmer
            className="mr-15 rounded-full"
            style={{ height: "40px", width: "40px" }}
          />
          <div>
            <Shimmer
              className="mb-5"
              style={{ height: "10px", width: "100px" }}
            />
            <Shimmer style={{ height: "10px", width: "160px" }} />
          </div>
        </div>
        <Shimmer style={{ height: "14px", width: "60px" }} />
      </div>
    </div>
  ))
}

export default WizardLoading
